import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

/* tailwind-merge reads `text-note` as a text COLOUR and drops the size in silence.
   Declaring the scale as font-size restores the two groups — so EVERY step of the
   scale has to be listed below (packages/ui/docs/trappole.md § «cn() va aggiornato»). */
const twMerge = extendTailwindMerge({
  extend: {
    // `rounded-pill` and `rounded-sheet` are not t-shirt sizes: without this they conflict with
    // no other radius.
    theme: { radius: ['pill', 'sheet'] },
    classGroups: {
      'font-size': [
        {
          text: [
            'hero',
            'hero-long',
            'page-title',
            'figure',
            'entry-headline',
            'entry-headline-wide',
            'section-title',
            'team-title',
            'eyebrow',
            'tab',
            'row-title',
            'body',
            'note',
            'note-strong',
            'count',
            'tile-code',
            'shirt-number',
            'player-given',
            'player-given-long',
            'player-given-wide',
            'player-family',
            'player-family-long',
            'player-family-wide',
            'player-initials',
          ],
        },
      ],
    },
  },
})

/** Merges Tailwind classes, resolving conflicts: the last one wins. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
